import { useCondominioImpersonation } from "@/contexts/CondominioImpersonationContext";
import { VerComoPersonasSelector } from "@/components/admin/VerComoPersonasSelector";

/**
 * "Ver como" del Portal Condominio: por persona (regla de Eduardo, 2026-10-27). Solo quien entra
 * al portal, en bloques por rol; al elegir a alguien se ven sus menús y sus condominios.
 */
export function CondominioImpersonationSelector({ className, compacto }: { className?: string; compacto?: boolean }) {
  const { impersonatedEmail, impersonatedName, setImpersonated, clearImpersonation } = useCondominioImpersonation();
  return (
    <VerComoPersonasSelector
      rutas={["/admin/portal-condominio/%"]}
      seleccionadoEmail={impersonatedEmail}
      seleccionadoNombre={impersonatedName}
      onElegir={(p) => setImpersonated(p.email, p.nombre, p.personaId, p.rolAccesoId, p.rolAccesoNombre)}
      onLimpiar={clearImpersonation}
      compacto={compacto}
      className={className}
    />
  );
}
